import { render, staticRenderFns } from "./flipper.vue?vue&type=template&id=ca005d4c&"
import script from "./flipper.vue?vue&type=script&lang=js&"
export * from "./flipper.vue?vue&type=script&lang=js&"
import style0 from "./flipper.vue?vue&type=style&index=0&id=ca005d4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports